import juniorAndSeniorConsultant from './juniorAndSeniorConsultant';
import freshEntryConsultant from './freshEntryConsultant';
import midLevelConsultant from './midLevelConsultant';

const jobList = [juniorAndSeniorConsultant, freshEntryConsultant, midLevelConsultant];

export default jobList;
